var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardAssignment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.4,
    height: 48,
    viewBox: "0 0 38.4 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.25;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28,2H8.8A4.8,4.8,0,0,0,4,6.8V45.2A4.783,4.783,0,0,0,8.8,50H37.6a4.783,4.783,0,0,0,4.8-4.8V16.4L28,2m9.6,43.2H8.8V6.8H25.6v12h12V45.2M24.5,41.6V36.8H14.9V32h9.6V27.2l7.2,7.2Z",
    transform: "translate(-4 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardAssignment);
export default __webpack_public_path__ + "static/media/dashboardAssignment.c75ebabbd1ed0089cfd97ab36c52393e.svg";
export { ForwardRef as ReactComponent };